export function unwrap(value) {
  if (Array.isArray(value) && value.length === 1) {
    return value[0];
  }
  return value;
}
